// New client/src/services/userProductService.js
import { api } from "./api";

class UserProductService {
  // Get user's assigned products
  async getUserProducts(userId) {
    try {
      const response = await api.get(`/user-products/users/${userId}/products`);
      return response.data;
    } catch (error) {
      console.error("Error fetching user products:", error);
      throw error.response?.data || error;
    }
  }

  // Assign products to user (admin only)
  // products: [{ productId, isLicenseServer }]
  async assignProductsToUser(userId, products) {
    try {
      const response = await api.put(
        `/user-products/users/${userId}/products`,
        {
          products,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error assigning products to user:", error);
      throw error.response?.data || error;
    }
  }

  // Remove product from user (admin only)
  async removeProductFromUser(userId, productId) {
    try {
      const response = await api.delete(
        `/user-products/users/${userId}/products/${productId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error removing product from user:", error);
      throw error.response?.data || error;
    }
  }

  // Get all users with their assigned products (admin only)
  async getAllUsersWithProducts(page = 1, limit = 10, search = "") {
    try {
      const response = await api.get("/user-products/users-with-products", {
        params: { page, limit, search },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching users with products:", error);
      throw error.response?.data || error;
    }
  }

  // Get current user's assigned products
  async getMyProducts() {
    try {
      const response = await api.get("/user-products/my-products");
      return response.data;
    } catch (error) {
      console.error("Error fetching my products:", error);
      throw error.response?.data || error;
    }
  }
}

export const userProductService = new UserProductService();
